import React from "react";
import Axios from 'axios'
import API from '../Utils/api'
import DetalhamentoPedido from "../_Components/DetalhamentoPedido";
import moment from 'moment';
import GerenteTemplate from './GerenteTemplate';
import Cleave from "cleave.js/react";
import loading from '../Assets/images/loading.gif';


export class BilhetesGerente extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    this.state = {
      pedidos: [],
      user: JSON.parse(localStorage.getItem("user")),
      isLoading: false,
      clienteSelecionado: null,
      pedidoSelecionado: null,
      cartelas: [],
      clientes: [],
      searchedPedidos: [],
      detalahamento: false,
      historicos: [],
      historicoSelecionado: undefined,
      ultimohistoricoSelecionado: undefined,
      tipoDePedido: "",
      vendedorSelecionado: {target: {value: "todos"}},
      cambistas: [],
      relatorio: {
        totCardPix: 0, 
        fatPix: 0, 
        comissaoPix: 0,
        totCardWp: 0, 
        fatWp: 0, 
        comissaoWp: 0,
        totCardPanfleto: 0 , 
        fatPanfleto: 0,
        comissaoPanfleto: 0, 
        totCardAvulso: 0, 
        fatAvulso: 0,
        comissaoAvulso: 0, 
        totCardSite: 0, 
        fatSite: 0, 
        comissaoSite: 0,
        totCardGeral: 0, 
        fatGeral: 0,
        comissaoGeralVendedores: 0,
        comissaoGerente: 0,
        totCardCredit: 0,
        fatCardCredit: 0,
        comissaoCredit: 0,
        desconto: 0
      }
    };   
    this.getDescontoCredito();
    this.listarPedidos();
    this.getHistoricos();
    this.selecionarPedido = this.selecionarPedido.bind(this)
    this.deselecionarPedido = this.deselecionarPedido.bind(this)
    this.getPedidoPorTransacao = this.getPedidoPorTransacao.bind(this)
    this.receberTodosPedidos = this.receberTodosPedidos.bind(this)

  }

  getDescontoCredito = async (e) => {
    try {
      const response = await API.get("/api/parametros/desconto")
      this.setState({ desconto: response.data});

    } catch (err) {
      console.log(err);
    }
  };

  listarCambistas = async (e) => {
    const usuario = this.state.user;
    try {
      const response = await API.post("/api/usuarios/listar-ativos-por-tutor",
        {
          tutorId: usuario._id
        });
      this.setState({ cambistas: response.data.sort(this.compararNome)});

    } catch (err) {
      console.log(err);
    }
  };


  async getHistoricos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      })
      const response = await axiosInstance.get("historicos/")

      this.setState({ historicos: response.data.sort(this.compararDatas), ultimohistoricoSelecionado : {_id: ""} })

    } catch (err) {
      console.log(err)
    }
  }

  compararDatas(a, b) {
    var A = new Date(a.dataInicial)
    var B = new Date(b.dataInicial)
    if (A < B) {
      return 1;
    }
    if (A > B) {
      return -1;
    }

    return 0
  }


  async deletarPedidoVazio() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/deletar-vazios", {
      });
    } catch (err) {
      console.log(err);
    }
  }

  deselecionarPedido(event) {
    this.setState({ pedidoSelecionado: null, clienteSelecionado: null })
    this.setState({ detalahamento: false })
    this.forceUpdate()

  }

  selecionarPedido(event) {
    const pedido = JSON.parse(event.target.accessKey)
    this.setState({ pedidoSelecionado: event.target.accessKey, clienteSelecionado: JSON.stringify(pedido.clienteId) })
    this.setState({ detalahamento: true })
    this.forceUpdate()
  }


  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  getUser = async (e) => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });

      window.localStorage.setItem("user", JSON.stringify(response.data[0]));
      this.setState({ user: response.data[0] });
    } catch (err) {
      console.log(err);
    }
  };

  filtrarCambistas(){
    let cambistas = [];
    let cambistasIds = [];
    this.state.pedidos.map(pedido => {
      if(!cambistasIds.includes(pedido.cambistaId._id.toString())){
        cambistas.push(pedido.cambistaId);
        cambistasIds.push(pedido.cambistaId._id.toString());
      }
    })
    this.setState({cambistas: cambistas.sort(this.compararNome)});
    this.setState({isLoading: false})
    this.filtrarPorCambista(this.state.vendedorSelecionado)
  }

  listarPedidos = async (e) => {
    this.setState({isLoading: true})
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("pedidos/listar-pedidos-populate-transaction", {
        id: this.state.user._id
      });
      this.setState({ pedidos: response.data.reverse()});
      this.filtrarCambistas(response.data);
      //this.filtrarPorCambista(this.state.vendedorSelecionado)
    } catch (err) {
      console.log(err);
      this.setState({isLoading: false})
    }
  };

  filtrarTipoDePedido(tipoDePedido){
    if(tipoDePedido != ""){
      var pedidos = [];
      this.state.pedidos.map(pedido => {
        if(pedido.transacaoId.documento == tipoDePedido || pedido.transacaoId.observacao == tipoDePedido){
          pedidos.push(pedido)
        }
      })
      this.setState({searchedPedidos: pedidos})
    }
    else{
      this.setState({searchedPedidos: this.state.pedidos})
    }
  }

  async buscarPedidosIntervalo(historicoSelecionado) {
    this.setState({isLoading: true})
    if (historicoSelecionado && this.state.ultimohistoricoSelecionado._id != historicoSelecionado._id ) {
      this.setState({ isLoad: true, ultimohistoricoSelecionado: historicoSelecionado })
      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        })
        const response = await axiosInstance.post("pedidos/intervalo-gerente",
          {
            dataInicial: historicoSelecionado.dataInicial,
            dataFinal: historicoSelecionado.dataFinal,
            gerenteId: this.state.user._id,
          })

        this.setState({ pedidos: response.data.reverse()})
        //this.filtrarPorCambista(this.state.vendedorSelecionado)
        this.filtrarCambistas(response.data);
      } catch (err) {
        console.log(err)
        this.setState({isLoading: false})
      }
    }
    else {
      //this.filtrarPorCambista(this.state.vendedorSelecionado)
      //this.listarPedidos();
    }
  }

  receberTodosPedidos() {

    var index = 0;
    var pedidos = this.state.pedidos.filter(pedido => pedido.recebido == false);

    var user = this.state.user
    var intervalo = setInterval(async function () {
      if (index >= pedidos.length) {
        clearInterval(intervalo);
      }

      var pedido = pedidos[index]

      try {
        var axiosInstance = new Axios.create({
          baseURL: window.localStorage.getItem("apiUrl")
        });
        const transacao = await axiosInstance.post(
          'transacoes/criar-transacao',
          {
            data: new Date(),
            documento: pedido.codigo,
            valor: pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor),
            emissorId: pedido.clienteId._id,
            receptorId: pedido.cambistaId._id,
            tipo: 'Venda',
            observacao: 'VENDA CAMBISTA',
            status: true,
            natureza: 'ENTRADA',
            isEfetivada: false,
            taxaComissao: ((pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor)) / 100) * pedido.cambistaId.comissao
          }


        )
        if (transacao.data) {
          var receberP = await axiosInstance.post('pedidos/receber-pedido', {
            codigo: pedido.codigo,
            cambistaId: pedido.cambistaId._id,
            gerenteId: user._id,
            transacaoId: transacao.data._id
          })

        }
      } catch (err) {
        console.log(err);
      }
      index++;
    }, 200);

  }

  async getPedidoPorTransacao(e) {
    try {
      const response = await API.post("/api/pedidos/por-transacao", {
        transacaoId: e._id
      });
      return response.data
    } catch (err) {
      console.log(err);
    }
  };

  contarCartelas() {
    var cartelas = []
    this.state.pedidos.forEach(pedido => {
      pedido.cartelas.forEach(cartela => {
        cartelas.push(cartela)
      })
    })
    this.setState({ cartelas: cartelas })
  }

  async getClientesPorCambista(item) {
    this.setState({ pedidoSelecionado: item })
    try {
      const response = await API.post("/api/usuarios/listar-por-tutor", {
        tutorId: item.cambistaId._id
      });
      this.setState({ clientes: response.data.sort(this.compararNome) });
    } catch (err) {
      console.log(err);
    }
  };

  compararNome(a, b) {
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
      return 1;
    }
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
      return -1;
    }

    return 0
  }

  setCliente(e) {
    this.state.clienteSelecionado = JSON.parse(e.target.value);
    this.setState({ clienteSelecionado: JSON.parse(e.target.value) })
  }

  async salvarPedidoEditado() {
    this.state.pedidoSelecionado.clienteId = this.state.clienteSelecionado._id;
    this.state.pedidoSelecionado.cambistaId = this.state.clienteSelecionado.tutorId;
    if (this.state.clienteSelecionado) {
      try {
        const response = await API.post("/api/pedidos/modifica-pedido", {
          id: this.state.pedidoSelecionado._id,
          pedido: this.state.pedidoSelecionado
        });
        alert("Salvo com sucesso!")
        window.location.reload()
      } catch (err) {
        console.log(err);
      }
    }
  }

  searchCode(e) {
    var filter = [];
    this.state.pedidos.map(pedido => {

      pedido.cartelas.map(cartela => {
        if (cartela != undefined && cartela.codigo.includes(e.target.value)) {
          filter.push(pedido);
        }
      }
      )

    })
    { e.target.value != '' ? this.setState({ searchedPedidos: filter }) : this.setState({ searchedPedidos: this.state.pedidos }) }
  }


  selecionaIntervalo(e) {
    if (e.target.value !== 'NULL') {
      this.setState({ historicoSelecionado: JSON.parse(e.target.value).historico })
      this.buscarPedidosIntervalo(JSON.parse(e.target.value).historico);
      document.getElementById("atualvendedor").value = "todos";
    }
    else {
      this.setState({ historicoSelecionado: undefined })
      this.listarPedidos();
      document.getElementById("atualvendedor").value = "todos";
    }
  }

  handlerOnChange(event){
    this.setState({
      [event.target.name] : event.target.value
    })
    //this.filtrarTipoDePedido(event.target.value);
  }

  filtrarPorCambista(e){
    let arrayFilter = [];
    e.target = document.getElementById("atualvendedor");
    if(e.target.value == "todos"){
      this.setState({searchedPedidos : this.state.pedidos, vendedorSelecionado: {target: {value: "todos"}}});
      this.gerarRelatorio(this.state.pedidos);
    }
    else{
      this.state.pedidos.map(pedido => {
        if(pedido.cambistaId._id == JSON.parse(e.target.value)._id){
          arrayFilter.push(pedido)
        }
      })
      this.setState({searchedPedidos : arrayFilter , vendedorSelecionado: e});
      this.gerarRelatorio(arrayFilter);
    }

  }

  gerarRelatorio(pedidos){

    let relatorio =  {
      totCardPix: 0, 
      fatPix: 0, 
      comissaoPix: 0,
      totCardWp: 0, 
      fatWp: 0, 
      comissaoWp: 0,
      totCardPanfleto: 0 , 
      fatPanfleto: 0,
      comissaoPanfleto: 0, 
      totCardAvulso: 0, 
      fatAvulso: 0,
      comissaoAvulso: 0, 
      totCardSite: 0, 
      fatSite: 0, 
      comissaoSite: 0,
      totCardGeral: 0, 
      fatGeral: 0,
      comissaoGeralVendedores: 0,
      comissaoGerente: 0,
      totCardCredit: 0,
      fatCardCredit: 0,
      comissaoCredit: 0
    }
    pedidos.map(pedido => {
      if(pedido.recebido){
        if(pedido.isApp && pedido.isCredit){
          relatorio.totCardCredit += pedido.cartelas.length;
          relatorio.fatCardCredit += pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor);
          relatorio.comissaoCredit += pedido.cartelas.length *   pedido.cambistaId.comissao;
        }
        else if(pedido.isApp && pedido.isPixPayment && !pedido.isPanfleto){
          relatorio.totCardPix += pedido.cartelas.length;
          relatorio.fatPix += pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor);
          relatorio.comissaoPix += pedido.cartelas.length *  pedido.cambistaId.comissao;
        }
        else if(pedido.isApp && !pedido.isPixPayment && !pedido.isPanfleto){
          relatorio.totCardWp += pedido.cartelas.length;
          relatorio.fatWp += pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor);
          relatorio.comissaoWp += pedido.cartelas.length *  pedido.cambistaId.comissao;
        }
        else if(pedido.isApp && pedido.isPixPayment && pedido.isPanfleto){
          relatorio.totCardPanfleto += pedido.cartelas.length;
          relatorio.fatPanfleto += pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor);
          relatorio.comissaoPanfleto += pedido.cartelas.length *  pedido.cambistaId.comissao;
        }
        else if(!pedido.isApp && pedido.transacaoId.documento == "Documento Avulso"){
          relatorio.totCardAvulso += pedido.cartelas.length;
          relatorio.fatAvulso += pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor);
          relatorio.comissaoAvulso += pedido.cartelas.length *  pedido.cambistaId.comissao;
        }
        else if(!pedido.isApp){
          relatorio.totCardSite += pedido.cartelas.length;
          relatorio.fatSite += pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor);
          relatorio.comissaoSite += pedido.cartelas.length *  pedido.cambistaId.comissao;
        }
        relatorio.totCardGeral += pedido.cartelas.length;
        relatorio.fatGeral += pedido.cartelas.length * parseFloat(pedido.cartelas[0].valor);
        relatorio.comissaoGeralVendedores += pedido.cartelas.length *  pedido.cambistaId.comissao;
        relatorio.comissaoGerente += pedido.cartelas.length *  this.state.user.comissao;
      }
    })
    this.setState({relatorio: {...relatorio}})
    this.setState({isLoading: false})
  }

  render() {
    return (


      <GerenteTemplate label="Bilhetes">


        <div className="modal fade" id="exampleModalCenter2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '50vw' }} role="document">
            <div className="modal-content "  >
              <div className="modal-header">
                <h4 className="modal-title font-weight-bolder" id="exampleModalLongTitle">Editar o cliente do pedido</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <h4>Procure o cliente correto</h4>
                <select onChange={this.setCliente.bind(this)} style={{ zIndex: '3000' }} className="ml-1 custom-select">
                  <option value={JSON.stringify(null)} selected>Selecione um cliente</option>
                  {this.state.clientes.length > 0 ? this.state.clientes.map(cliente => {
                    return <option value={JSON.stringify(cliente)}>{cliente.nome} - {cliente.telefone}</option>
                  }) : ""}
                </select>
              </div>
              <div className="modal-footer" style={{ justifyContent: 'flex-end' }}>
                <button className="btn btn-fill btn-success" onClick={this.salvarPedidoEditado.bind(this)}>Salvar</button>
              </div>
            </div>
          </div>
        </div>




        <div onClick={this.deselecionarPedido} className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '95vw', marginTop: '-8em' }} role="document">
            <div className="modal-content "  >
              <div className="modal-header">
                <h4 className="modal-title font-weight-bolder" id="exampleModalLongTitle">Detalhamento pedido</h4>
                <button onClick={this.deselecionarPedido} type="button" className="close" data-dismiss="modal" aria-label="Close" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.detalahamento && this.state.pedidoSelecionado ? <DetalhamentoPedido user={this.state.clienteSelecionado} pedido={this.state.pedidoSelecionado} /> : ""}
              </div>
              <div className="modal-footer" style={{ justifyContent: 'flex-end' }}>

              </div>
            </div>
          </div>
        </div>
        <div className="content">
              {this.state.isLoading? 
                 <div className='sf-modal'>
                    <img className='sf-loading' src={loading}></img>
                </div> : ""}
          <div className="container-fluid">
            <div className="row">

              <div className="col-md-12">
                <div className="card strpied-tabled-with-hover">
                  <div className="card-header ">
                    <h4 className="card-title">
                      Acompanhe pedidos e relatórios de venda
                    </h4>
                  </div>
                  <div className="card-body table-full-width">
                    <div style={{ paddingLeft: window.innerWidth >= 1024? "15em" : 0, display: 'flex' , flexWrap: 'wrap'   }}>
          
                      <Cleave
                        style={{ maxWidth: "20em" }}
                        data-length="7"
                        className={`m-2 form-control border-secondary`}
                        options={{
                          numericOnly: true,
                          delimiters: ['-'],
                          blocks: [5, 1]
                        }}

                        onChange={this.searchCode.bind(this)}
                        placeholder="código da cartela 00000-0"

                      />
           

                      <select onChange={this.selecionaIntervalo.bind(this)} className="custom-select m-2" style={{ width: window.innerWidth >= 1024? 'auto' : "40%"}}>
                        <option value={'NULL'} selected >Cartelas atuais</option>
                        {this.state.historicos.map(historico => {
                          return <option value={JSON.stringify({ historico })}>{this.formatDate(historico.dataInicial)} ➨ {this.formatDate(historico.dataFinal)} </option>
                        })}
                      </select>
                      <select name="vendedores" id="atualvendedor" className={"custom-select m-2"} style={{ width: window.innerWidth >= 1024? 'auto' : "40%"}}>
                          <option value={"todos"}>Todos</option>
                          {this.state.cambistas.map(cambista => 
                              <option value={JSON.stringify(cambista)}>{cambista.nome} </option>
                          )}
                      </select>
                      <button className="btn-fill btn btn-danger m-2" type="button" onClick={() => {this.filtrarPorCambista({target: {value: 'todos'}})}} style={{ marginLeft: window.innerWidth >= 1024? '2em' : "0.5em"}}> Filtrar</button>
                    </div>
                    <div style={{width: '100%', display: 'flex', justifyContent:'center'}}>
                    <div style={{width: window.innerWidth <= 900? window.innerWidth : '1280px', display: 'flex', flexDirection: 'column', alignItems: 'center', overflowX: window.innerWidth <= 900? 'scroll': 'hidden'}}>
                      <div id="tabela1" style={{marginLeft: window.innerWidth <= 900? '300px' : 0, width: window.innerWidth <= 900? "600px" : "1280px", display: 'flex', flexDirection: 'column' , marginTop: '2em'}}>
                          <div style={{width: "100%" , display: 'flex', flexDirection: 'row', backgroundColor: '#a4dbb3', justifyContent: 'space-around'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Pré-pago</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Q. Cartelas</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Arrecadado</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Css. Vendedor</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Css Supervisor</div>
                          </div>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Link Afiliado</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardPix}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.fatPix}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.comissaoPix}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardPix * this.state.user.comissao}</div>
                          </div>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around', backgroundColor:'rgba(0, 0, 0, .05)'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Panfleto</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardPanfleto}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.fatPanfleto}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.comissaoPanfleto}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardPanfleto * this.state.user.comissao}</div>
                          </div>

                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around', backgroundColor:'rgba(0, 0, 0, .05)'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Crédito</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardCredit}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.fatCardCredit}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.comissaoCredit}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardCredit * this.state.user.comissao}</div>
                          </div>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Total</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{this.state.relatorio.totCardPix + this.state.relatorio.totCardPanfleto}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{this.state.relatorio.fatPix + this.state.relatorio.fatPanfleto}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{this.state.relatorio.comissaoPix + this.state.relatorio.comissaoPanfleto}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{(this.state.relatorio.totCardCredit + this.state.relatorio.totCardPix + this.state.relatorio.totCardPanfleto) * this.state.user.comissao}</div>
                          </div>
                      </div>


                      <div id="tabela2" style={{marginLeft: window.innerWidth <= 900? '300px' : 0, width: window.innerWidth <= 900? "600px" : "1280px",  display: 'flex', flexDirection: 'column' , marginTop: '2em'}}>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row', backgroundColor: '#a4dbb3', justifyContent: 'space-around'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Pós-pago</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Q. Cartelas</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Arrecadado</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Css. Vendedor</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Css Supervisor</div>
                          </div>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Whatssapp</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardWp}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.fatWp}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.comissaoWp}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardWp * this.state.user.comissao}</div>
                          </div>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around', backgroundColor:'rgba(0, 0, 0, .05)'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Site</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardSite}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.fatSite}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.comissaoSite}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardSite * this.state.user.comissao}</div>
                          </div>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Avulsa</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardAvulso}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.fatAvulso}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.comissaoAvulso}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{this.state.relatorio.totCardAvulso * this.state.user.comissao}</div>
                          </div>
                          <div style={{width: '100%' , display: 'flex', flexDirection: 'row',  justifyContent: 'space-around', backgroundColor:'rgba(0, 0, 0, .05)'}}>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>Total</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{this.state.relatorio.totCardWp + this.state.relatorio.totCardSite + this.state.relatorio.totCardAvulso}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{this.state.relatorio.fatWp + this.state.relatorio.fatSite + this.state.relatorio.fatAvulso}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{this.state.relatorio.comissaoWp + this.state.relatorio.comissaoSite  + this.state.relatorio.comissaoAvulso}</div>
                              <div style={{width: '20%', height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>{(this.state.relatorio.totCardWp + this.state.relatorio.totCardSite + this.state.relatorio.totCardAvulso) * this.state.user.comissao}</div>
                          </div>
                      </div>
                      <div style={{ marginTop: '10px', display: 'flex', justifyContent: window.innerWidth <= 900? 'center' : 'start', width: '1280px', height: "32px"}}>
                        <div style={{border: '2px solid black', display: 'flex', justifyContent: 'center', width: '256px'}}>
                            {this.state.vendedorSelecionado.target.value != 'todos'? 
                            <b><span>Repasse para gerencia : R$ {(this.state.relatorio.fatWp + this.state.relatorio.fatSite + this.state.relatorio.fatAvulso)- (this.state.relatorio.comissaoWp + this.state.relatorio.comissaoSite  + this.state.relatorio.comissaoAvulso)}</span></b>
                            :<b><span> Repasse pós-pago : R$  {(this.state.relatorio.fatWp + this.state.relatorio.fatSite + this.state.relatorio.fatAvulso)- (this.state.relatorio.comissaoWp + this.state.relatorio.comissaoSite  + this.state.relatorio.comissaoAvulso) - ((this.state.relatorio.totCardWp + this.state.relatorio.totCardSite + this.state.relatorio.totCardAvulso) * this.state.user.comissao) - (this.state.relatorio.totCardCredit + this.state.relatorio.totCardPix + this.state.relatorio.totCardPanfleto) * this.state.user.comissao} </span></b>}
                        </div>
                      </div>
                    </div>

                    </div>

         
                    <table className="table table-hover table-striped">
  <thead>
    <tr>
      <th>Via</th>
      <th>Pagamento</th>
      <th>Data</th>
      <th>Codigo</th>
      <th>Cartelas</th>
      <th>Cliente</th>
      <th>Vendedor</th>
      <th>Qtd de cartelas</th>
      <th>Valor total</th>
      <th className={this.state.historicoSelecionado ? 'd-none' : ''}>Editar</th>
    </tr>
  </thead>
  <tbody>
    {this.state.searchedPedidos.length > 0
      ? this.state.searchedPedidos.map(
        (item, index) => {
          return (
            <tr>
              <td>{item.isCredit? "Crédito": item.isPanfleto? "Panfleto" : item.isPixPayment? "Pix" : item.isApp? "Whatsapp" : item.transacaoId.documento == "Documento Avulso"? "Avulso" : "Site"}</td>
              <td style={{fontWeight: "bold", color : item.recebido ? "#5bb313" : "#caa705"}}>{item.recebido? "recebido" : "pendente"}</td>
              <td>{this.formatDate(item.data)}</td>
              <td style={{ cursor: 'pointer' }}
                accessKey={JSON.stringify(item)}
                data-toggle="modal" data-target="#exampleModalCenter"
                onClick={this.selecionarPedido}>{item.codigo}</td>
              <td accessKey={JSON.stringify(item)}>
                {item.cartelas ? 
                  <a className="cursor-pointer" data-toggle="tooltip" data-placement="top" title={item.cartelas.slice(0,2).map(cartela => cartela.codigo).join(", ") }>{item.cartelas.slice(0,2).map(cartela => cartela.codigo).join(", ") + "..."}</a>
                  : "N/A"
                }
              </td>
              <td accessKey={JSON.stringify(item)}>{item.clienteId ? item.clienteId.nome : "Desconhecido"}</td>
              <td accessKey={JSON.stringify(item)}>{item.cambistaId ? item.cambistaId.nome : "Desconhecido"}</td>
              <td accessKey={JSON.stringify(item)} className="pl-5">{item.cartelas ? item.cartelas.length : "0"}</td>
              <td accessKey={JSON.stringify(item)} className="pl-5">{item.cartelas ? (item.cartelas[0] ? (item.cartelas.length * item.cartelas[0].valor).toFixed(2) : "0") : "0"}</td>
              <td className={this.state.historicoSelecionado ? 'd-none' : ''}><button className="btn" data-toggle="modal" data-target="#exampleModalCenter2" onClick={() => this.getClientesPorCambista(item)} >Editar</button></td>
            </tr>
          );
        }
      )
      : ""}
  </tbody>
</table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </GerenteTemplate>
    );
  }
}

export default BilhetesGerente;
